import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'app-donut-legend-item',
	templateUrl: './donut-legend-item.component.html',
	styleUrls: ['./donut-legend-item.component.css']
})
export class DonutLegendItemComponent implements OnInit {
	@Input() legendItem: any;

	@Output() legendClicked = new EventEmitter<any>();

	constructor() {}

	ngOnInit() {}

	selectLegend() {
		this.legendClicked.emit(this.legendItem);
	}
}
